<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="stockRoadwaySelected"
    :clearable="!unclearable"
    :items="stock_roadway"
    :loading="Loading"
    :search-input.sync="search"
    item-text="code"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('stockRoadway.ObjectName')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
    :disabled="disabled"
  ></v-autocomplete>
</template>

<script>
import stockRoadways from "@/api/stock_roadways";

export default {
  name: "SearcherRoadway",

  props: {
    value: Object,
    stockId: Number,
    noLabel: Boolean,
    label: String,
    dense: Boolean,
    disabled: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
  },

  data: () => ({
    stock_roadway: [],
    Loading: false,
    search: "",
    stockRoadwaySelected: null,
  }),

  mounted() {
    this.getStockRoadwayFromAPI();
  },

  methods: {
    getStockRoadwayFromAPI() {
      this.Loading = true;
      stockRoadways.fetchAllForSelect({stock_ids: this.stockId})
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stock_roadway = response.data.stock_roadways;
            }
            this.Loading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.Loading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.stockRoadwaySelected = this.value;
      },
    },
    stockRoadwaySelected: {
      handler() {
        this.$emit("input", this.stockRoadwaySelected);
      },
    },
    stockId: {
      handler() {
        this.getStockRoadwayFromAPI();
      }
    }
  },
};
</script>
